import * as types from './mutation-types'

export default {
  setAuthenticated ({ commit }, payload) {
    commit(types.SET_AUTHENTICATED, payload)
  }
}
